import { render, staticRenderFns } from "./cpt-vip.vue?vue&type=template&id=d5e0ad78&scoped=true&"
import script from "./cpt-vip.vue?vue&type=script&lang=js&"
export * from "./cpt-vip.vue?vue&type=script&lang=js&"
import style0 from "./cpt-vip.vue?vue&type=style&index=0&id=d5e0ad78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e0ad78",
  null
  
)

export default component.exports